var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1599_23268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.72397 5.14648H0.511969C0.369406 5.14648 0.253906 5.26205 0.253906 5.40455V15.7234C0.253906 15.866 0.369406 15.9815 0.511969 15.9815H3.72397C3.86653 15.9815 3.98203 15.866 3.98203 15.7234V5.40455C3.98203 5.26205 3.86653 5.14648 3.72397 5.14648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.11953 0.0166016C0.950813 0.0166016 0 0.966383 0 2.13382C0 3.30176 0.950813 4.25191 2.11953 4.25191C3.28731 4.25191 4.23738 3.30173 4.23738 2.13382C4.23741 0.966383 3.28734 0.0166016 2.11953 0.0166016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8948 4.88965C10.6047 4.88965 9.65109 5.44424 9.07266 6.07437V5.40418C9.07266 5.26168 8.95716 5.14612 8.81459 5.14612H5.73853C5.59597 5.14612 5.48047 5.26168 5.48047 5.40418V15.7231C5.48047 15.8656 5.59597 15.9811 5.73853 15.9811H8.94353C9.08609 15.9811 9.20159 15.8656 9.20159 15.7231V10.6176C9.20159 8.89721 9.66891 8.22696 10.8682 8.22696C12.1743 8.22696 12.2781 9.30143 12.2781 10.7061V15.7231C12.2781 15.8657 12.3936 15.9812 12.5362 15.9812H15.7423C15.8849 15.9812 16.0004 15.8657 16.0004 15.7231V10.063C16.0004 7.50484 15.5126 4.88965 11.8948 4.88965Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1599_23268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinWhite);
export default __webpack_public_path__ + "static/media/linkedin-white.ef5cf80625b9cc32c333f3d97b02050f.svg";
export { ForwardRef as ReactComponent };